import script from "./MHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MHomePage.vue?vue&type=script&setup=true&lang=js"

import "./MHomePage.vue?vue&type=style&index=0&id=e2e52636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2e52636"]])

export default __exports__